<div class="flex flex-col items-center flex-shrink-0 lg:mt-20 max-w-360">
  <p class="text-center">&copy; {{copyYear}} Alphastar Capital Management, LLC<br>All Rights Reserved.</p>
</div>